import { useQuery } from '@apollo/client/react';
import { BLOG_PAGINATION_POSTS_QUERY } from '../../graphql/blog-queries';

export default function useGetBlogPaginationPosts(variables) {
    const { data, loading } = useQuery(BLOG_PAGINATION_POSTS_QUERY, { variables });
    return { data, loading };
}
